import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import type { ReferenceCardLocationState } from '../types/referenceCardNavigation';

/**
 * true, если карточка открыта поверх списка (в state есть backgroundLocation).
 * Закрытие: history back — возврат к предыдущему location (фон).
 */
export function useReferenceCardOverlay() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as ReferenceCardLocationState | null;
  const isOverlay = Boolean(state?.backgroundLocation);
  const close = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  return { isOverlay, close };
}
